@if (image) {
  <ss-www-image-with-loader
    class="relative rounded-2xl"
    [fileDetail]="image"
    [desktopImageSize]="desktopImageSize"
    [ngClass]="heightClass"
    cdkMonitorSubtreeFocus
  >
    @if (url.startsWith('/')) {
      <a
        [routerLink]="[url]"
        (click)="dispatchBigImageLinkClicked()"
        [attr.cdkFocusInitial]="first ? '' : null"
        [attr.cdkFocusRegionEnd]="last ? '' : null"
        class="absolute top-0 left-0 right-0 bottom-0 image-cover-bg flex flex-col justify-center items-center"
      >
        <ng-container *ngTemplateOutlet="bigLinkContent"></ng-container>
      </a>
    } @else {
      <a
        [href]="url"
        (click)="dispatchBigImageLinkClicked()"
        [attr.cdkFocusInitial]="first ? '' : null"
        [attr.cdkFocusRegionEnd]="last ? '' : null"
        class="absolute top-0 left-0 right-0 bottom-0 image-cover-bg flex flex-col justify-center items-center"
      >
        <ng-container *ngTemplateOutlet="bigLinkContent"></ng-container>
      </a>
    }
    <ng-template #bigLinkContent>
      <div
        class="text-center uppercase lg:text-2xl lg:tracking-wider font-campan text-base md:text-xl mb-2 max-md:leading-7 tracking-[0.54px] md:tracking-[0.72px] font-medium"
      >
        {{ titleText }}
      </div>
    </ng-template>
  </ss-www-image-with-loader>
}
